import React from 'react';
import PropTypes from 'prop-types';
import {Route} from 'react-router-dom';
import {CurrentUser} from '../../services/CurrentUser';
import settings from "../../configs/appSettings";
import authService from '../../services/api/AuthenticationService';

const SecureRoute = ({component: Component, ...rest}) => {
    if (CurrentUser !== undefined && CurrentUser.isValid())
        return (<Route {...rest} render={props => (<Component {...props} />)}/>);
        authService.checkForAndInformParentOfTimeout(settings.northBaseUrl);
    window.location.replace(`${settings.authUiUrl}?referrer=${settings.clientId}`);

    return (<div/>);
};

SecureRoute.propTypes = {
    location: PropTypes.object,
    component: PropTypes.func
};

export default SecureRoute;
